export * from './types'
import { mutations } from './mutations'
import { actions, getters } from './actions'

export const eleicoes_conselho = {
  state: () => {
    return {
      votos: [],
      candidatos: []
    }
  },
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/eleicoes_conselho/index.js